class CartTermsAndConditions {
  constructor() {
    this.checkbox = document.querySelector('[data-cart-terms-checkbox]');
    this.cartButtons = this.getCartButtons();
    this.init();
  }

  init() {
    if (!this.checkbox) return;
    
    // Set initial state
    this.updateButtonStates();
    
    // Add event listener
    this.checkbox.addEventListener('change', () => {
      this.updateButtonStates();
    });
  }

  getCartButtons() {
    return document.querySelectorAll(
      '#CartDrawer-Checkout, #CartDrawer-ViewCart, .cart__checkout-button'
    );
  }

  updateButtonStates() {
    const isChecked = this.checkbox.checked;
    
    this.cartButtons.forEach(button => {
      if (isChecked) {
        button.disabled = false;
        button.classList.remove('button--disabled');
        button.removeAttribute('aria-disabled');
      } else {
        button.disabled = true;
        button.classList.add('button--disabled');
        button.setAttribute('aria-disabled', 'true');
      }
    });
  }
}

// Initialize when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CartTermsAndConditions();
  });
} else {
  new CartTermsAndConditions();
}

// Re-initialize when cart drawer content is updated
document.addEventListener('cart:updated', () => {
  // Small delay to ensure DOM is updated
  setTimeout(() => {
    new CartTermsAndConditions();
  }, 100);
});
